import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: '[activitiesMessage]',
  templateUrl: './activities-message.component.html',
})
export class ActivitiesMessageComponent implements OnInit {

  @Input()  item: any;
  constructor()
  {

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/activities/activities-message/activities-message.component.ts